document.addEventListener('DOMContentLoaded', function() {
    // Reset flag when page is loaded
    accordionsInitialized = false;
    
    initBentoBox();
    initBentoBoxVideos();
    
    // Initialize accordions once with delay
    setTimeout(function() {
      initBentoBoxAccordions();
    }, 500);
    
    // Custom event to reinitialize accordions if needed
    document.addEventListener('reinit-bento-accordions', function() {
      // Only reinitialize if needed
      accordionsInitialized = false;
      initBentoBoxAccordions();
    });
  }
);

// Only define the class if it doesn't already exist
if (typeof window.BentoBoxSwiper==='undefined') {
  window.BentoBoxSwiper=class BentoBoxSwiper {
    constructor() {
      this.sections=document.querySelectorAll('.bento-box');
      this.init();
    }

    init() {
      this.sections.forEach(section=> {
          const sectionId=section.dataset.sectionId;
          const swiperContainer=section.querySelector('.bento-box-swiper');
          const gridContainer=section.querySelector('.bento-box__grid');
          const sliderContainer=section.querySelector('.bento-box__slider');

          if ( !swiperContainer || !gridContainer || !sliderContainer) return;

          // Check if Swiper is defined and the element is a proper Swiper element
          if (typeof customElements==='undefined'|| !customElements.get('swiper-container') || typeof swiperContainer.initialize==='undefined') {
            console.log('Swiper Element not available yet, will retry');
            setTimeout(()=> this.init(), 500);
            return;
          }

          const params= {
            injectStyles: [` :host {
              display: block;
              width: 100%;
            }

            .swiper {
              width: 100%;
              overflow: visible;
            }

            .swiper-slide {
             position: relative;
           }

            ::slotted(swiper-slide) {
              height: auto;
            }
            
            `],
            init: true,
            slidesPerView: 1.1,
            spaceBetween: 20,
            watchOverflow: true,
            observer: true,
            observeParents: true,
            resizeObserver: true,
            speed: 300,
            autoHeight: false,
            effect: 'slide',
            on: {
              beforeInit() {
                if (this.el) {
                  this.el.style.display='block';
                  this.el.style.width='100%';
                }
              }

              ,
              init(swiper) {
                this.slideTo(0);

                setTimeout(()=> {
                    swiper.update();
                  }

                  , 50);
              }
            }
          }

          ;

          // Configure and initialize Swiper
          Object.assign(swiperContainer, params);

          // Initialize swiper if it should be shown on mobile
          const showMobileSlider=sliderContainer.getAttribute('data-show-mobile-slider')==='true';

          if (showMobileSlider && window.innerWidth <=749) {
            sliderContainer.style.display='block';
            gridContainer.style.display='none';
          }

          swiperContainer.initialize();

          // Handle responsive layout changes
          const handleResize=()=> {
            const showMobileSlider=sliderContainer.getAttribute('data-show-mobile-slider')==='true';

            if (window.innerWidth <=749) {
              if (showMobileSlider) {
                gridContainer.style.display='none';
                sliderContainer.style.display='block';

                // Make sure swiper is initialized
                if (swiperContainer.swiper) {
                  setTimeout(()=> {
                      swiperContainer.swiper.update();
                    }

                    , 100);
                }
              }

              else {
                gridContainer.style.display='grid';
                sliderContainer.style.display='none';
              }
            }

            else {
              gridContainer.style.display='grid';
              sliderContainer.style.display='none';
            }
          }

          ;

          // Initial check
          handleResize();

          // Listen for resize events
          window.addEventListener('resize', handleResize);
        }

      );
    }

    destroy() {
      this.sections.forEach(section=> {
          const swiperContainer=section.querySelector('.bento-box-swiper');

          if (swiperContainer && swiperContainer.swiper) {
            swiperContainer.swiper.destroy();
          }
        }

      );
    }
  }
}

// Initialize video functionality
function initBentoBoxVideos() {
  const videoPlaceholders=document.querySelectorAll('.bento-box__video-placeholder');

  videoPlaceholders.forEach(placeholder=> {
      placeholder.addEventListener('click', function() {
          const videoContainer=this.closest('.bento-box__video-container');
          const videoEmbed=videoContainer.querySelector('.bento-box__video-embed');
          const videoType=videoEmbed.dataset.videoType;
          const videoId=videoEmbed.dataset.videoId;

          if ( !videoType || !videoId) return;

          // Hide the placeholder and show the video
          this.style.display='none';
          videoEmbed.style.display='block';

          // Clear any existing videos in the container to prevent duplicates
          videoEmbed.innerHTML = '';

          // Create and embed the video based on type
          if (videoType==='vimeo') {
            const iframe=document.createElement('iframe');
            iframe.src=`https://player.vimeo.com/video/${videoId}?autoplay=1&title=0&byline=0&portrait=0`;
            iframe.width='100%';
            iframe.height='100%';
            iframe.allow='autoplay; fullscreen; picture-in-picture';
            iframe.frameBorder='0';
            iframe.style.aspectRatio='16/9';
            videoEmbed.appendChild(iframe);
          }

          else if (videoType==='shopify') {
            // For Shopify videos, use a video tag with the hosted URL
            const videoElement=document.createElement('video');
            
            // Parse the JSON string to get the actual video URL/data
            try {
              const videoData = JSON.parse(videoId);
              // For Shopify videos, we need to access the sources
              if (videoData && videoData.sources && videoData.sources.length) {
                videoElement.src = videoData.sources[0].url;
              } else {
                console.error('Invalid Shopify video data structure', videoData);
                return;
              }
            } catch (e) {
              console.error('Error parsing video data:', e);
              return;
            }
            
            videoElement.controls=true;
            videoElement.autoplay=true;
            videoElement.width='100%';
            videoElement.height='100%';
            videoElement.style.aspectRatio='16/9';
            videoEmbed.appendChild(videoElement);
          }
        }

      );
    }

  );
}

// Use window for the instance variable to prevent redeclaration
if (typeof window.bentoSwiper==='undefined') {
  window.bentoSwiper=null;
}

function initBentoBox() {
  if (window.bentoSwiper) {
    window.bentoSwiper.destroy();
  }

  window.bentoSwiper=new window.BentoBoxSwiper();
}

// Global flag to prevent multiple initializations
let accordionsInitialized = false;

// Initialize accordion functionality
function initBentoBoxAccordions() {
  // If already initialized recently, don't do it again
  if (accordionsInitialized) {
    return;
  }
  
  const toggleButtons = document.querySelectorAll('.bento-box__accordion-toggle');
  
  if (toggleButtons.length === 0) {
    // If no toggles are found, try again after a short delay
    setTimeout(initBentoBoxAccordions, 500);
    return;
  }
  
  // Set the initialization flag
  accordionsInitialized = true;
  
  // First, set all content to collapsed by default
  document.querySelectorAll('.bento-box__items-tested-content, .bento-box__faq-content').forEach(content => {
    content.style.maxHeight = '0px';
    content.style.overflow = 'hidden';
  });
  
  // Remove any existing event listeners
  toggleButtons.forEach(toggle => {
    const newToggle = toggle.cloneNode(true);
    toggle.parentNode.replaceChild(newToggle, toggle);
  });
  
  // Add fresh event listeners
  document.querySelectorAll('.bento-box__accordion-toggle').forEach(toggle => {
    toggle.addEventListener('click', function(e) {
      e.preventDefault();
      
      // Find the content container that follows this toggle
      const content = this.nextElementSibling;
      
      if (!content) {
        return;
      }
      
      // Find the parent accordion container (either FAQ or items tested)
      const parentAccordion = this.closest('.bento-box__faq-accordion, .bento-box__items-tested-accordion');
      
      // Check if this item is currently active
      const isCurrentlyActive = content.classList.contains('active');
      
      if (parentAccordion) {
        // Close all items in this accordion first
        parentAccordion.querySelectorAll('.bento-box__accordion-toggle').forEach(otherToggle => {
          otherToggle.classList.remove('active');
          const otherContent = otherToggle.nextElementSibling;
          if (otherContent) {
            otherContent.classList.remove('active');
            otherContent.style.maxHeight = '0px';
            otherContent.style.paddingBottom = '0px';
          }
        });
      }
      
      // If this item wasn't active, open it (if it was active, leave it closed)
      if (!isCurrentlyActive) {
        this.classList.add('active');
        content.classList.add('active');
        content.style.maxHeight = content.scrollHeight + 'px';
        content.style.paddingBottom = '15px';
      }
    });
  });
}

// Re-initialize on Shopify theme editor events
document.addEventListener('shopify:section:load', function(event) {
  if (event.detail.sectionId && event.detail.sectionId.includes('bento-box')) {
    // Reset flag for fresh initialization
    accordionsInitialized = false;
    
    setTimeout(function() {
      initBentoBox();
      initBentoBoxVideos();
      initBentoBoxAccordions();
    }, 300);
  }
});

document.addEventListener('shopify:section:select', function(event) {
  if (event.detail.sectionId && event.detail.sectionId.includes('bento-box')) {
    initBentoBox();
  }
});

document.addEventListener('shopify:section:deselect', function(event) {
  if (event.detail.sectionId && event.detail.sectionId.includes('bento-box')) {
    initBentoBox();
  }
});

document.addEventListener('shopify:block:select', function(event) {
  if (event.detail.sectionId && event.detail.sectionId.includes('bento-box')) {
    initBentoBox();
  }
});

document.addEventListener('shopify:block:deselect', function(event) {
  if (event.detail.sectionId && event.detail.sectionId.includes('bento-box')) {
    initBentoBox();
  }
});